import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  Tabs,
  Tab,
} from "@mui/material";
import axios from "axios";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import { Link } from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import HeaderName from "../HeaderName";
import SideBar from "../SideBar";
import { API_URL } from "../../../api/api";

function PaidCommissionSummary() {
  const token = localStorage.getItem("token");
  const url = API_URL();
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const [commissionSummaries, setCommissionSummaries] = useState([]);
  const [showDate, setShowDate] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [commissions, setCommissions] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [tabValue, setTabValue] = useState("doctor");

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedData = commissionSummaries.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  const _export = React.useRef(null);

  const excelExport = () => {
    if (_export.current !== null) {
      _export.current.save();
    }
  };

  const exportData = commissionSummaries.map((row, index) => {
    const firstCommission = row.relatedCommission[0];

    return {
      no: index + 1,
      doctorName:
        tabValue === "doctor"
          ? firstCommission?.relatedDoctor?.name
          : firstCommission?.relatedTherapist?.name || "N/A",
      collectedAmount: row.collectedAmount || 0,
      collectedDate: row.paidAt
        ? new Date(row.paidAt).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })
        : "N/A",
      remark: row.remark || "-",
      status: row.status || "-",
    };
  });

  const fetchCommissionSummaries = async (start = "", end = "") => {
    try {
      const params = {};

      if (start) {
        const startISO = new Date(start);
        startISO.setHours(0, 0, 0, 0);
        params.startDate = startISO.toISOString();
      }

      if (end) {
        const endISO = new Date(end);
        endISO.setHours(23, 59, 59, 999);
        params.endDate = endISO.toISOString();
      }

      params.commissionFor = tabValue === "doctor" ? "Doctor" : "Therapist";

      const res = await api.get("commission-logs", {
        params,
      });

      setCommissionSummaries(res.data.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchCommissionSummaries(startDate, endDate);
  }, [tabValue]);
  return (
    <div classNameName="App">
      <div className="wrapper">
        <HeaderName />

        {/* <!-- /.navbar --> */}

        {/* <!-- Main Sidebar Container --> */}
        <SideBar />

        {/* <!-- Content Wrapper. Contains page content --> */}
        <div className="content-wrapper">
          {/* <!-- Content Header (Page header) --> */}
          <Box p={2}>
            <h4 className="fs-5 py-3">Paid Commission</h4>
            <Box px={2} pb={2}>
              <Tabs
                value={tabValue}
                onChange={(e, newValue) => {
                  setTabValue(newValue);
                  setPage(0);
                }}
                textColor="primary"
                indicatorColor="primary"
              >
                <Tab label="Doctor" value="doctor" />
                <Tab label="Therapist" value="therapist" />
              </Tabs>
            </Box>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={3}>
                <Typography
                  sx={{
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    mb: 0.5,
                    color: "gray",
                  }}
                >
                  Start Date
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <Typography
                  sx={{
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    mb: 0.5,
                    color: "gray",
                  }}
                >
                  End Date
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </Grid>

              <Grid item xs={12} md={6} textAlign="right">
                <Button
                  variant="contained"
                  sx={{ backgroundColor: "#1565C0", mr: 1 }}
                  onClick={() => fetchCommissionSummaries(startDate, endDate)}
                >
                  Filter
                </Button>

                <Button
                  variant="contained"
                  sx={{ backgroundColor: "#1565C0" }}
                  onClick={excelExport}
                >
                  Export
                </Button>
              </Grid>
            </Grid>
          </Box>

          {/* <!-- Main content --> */}
          <Paper sx={{ p: 2, mt: 2, borderRadius: 2 }}>
            <div className="row">
              <div class="col-md-12 card px-3 py-3">
                <div class="table-responsive text-black" id="slimtest2">
                  <TableContainer
                    component={Paper}
                    sx={{ maxWidth: "100%", overflowX: "auto" }}
                  >
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            sx={{
                              color: "black",
                              fontWeight: "bold",
                              whiteSpace: "nowrap",
                            }}
                          >
                            #
                          </TableCell>

                          <TableCell
                            sx={{
                              color: "black",
                              fontWeight: "bold",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Collected Date
                          </TableCell>
                          <TableCell
                            sx={{
                              color: "black",
                              fontWeight: "bold",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Collected Amount
                          </TableCell>
                          <TableCell
                            sx={{
                              color: "black",
                              fontWeight: "bold",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Remark
                          </TableCell>
                          <TableCell
                            sx={{
                              color: "black",
                              fontWeight: "bold",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Status
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              color: "black",
                              fontWeight: "bold",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Action
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {paginatedData.map((row, index) => {
                          return (
                            <TableRow key={row._id}>
                              <TableCell>
                                {page * rowsPerPage + index + 1}
                              </TableCell>
                              <TableCell>
                                {new Date(row.paidAt).toLocaleDateString(
                                  "en-GB",
                                  {
                                    day: "2-digit",
                                    month: "short",
                                    year: "numeric",
                                  },
                                ) || "N/A"}
                              </TableCell>
                              <TableCell>
                                {row.collectedAmount?.toLocaleString() || "N/A"}
                              </TableCell>
                              <TableCell>{row.remark || "N/A"}</TableCell>
                              <TableCell>{row.status || "N/A"}</TableCell>
                              <TableCell align="center">
                                <Link
                                  className="btn btn-sm btn-success text-light"
                                  to={`/paid-commission-details/${row._id}`}
                                >
                                  Details
                                </Link>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    component="div"
                    count={commissionSummaries.length}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    labelRowsPerPage="Rows per page"
                    sx={{
                      marginTop: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      "& .MuiTablePagination-toolbar": {
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                      },
                      "& .MuiTablePagination-spacer": {
                        flex: "0 0 auto",
                      },
                      "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
                        {
                          marginTop: 0,
                          marginBottom: 0,
                        },
                    }}
                  />
                </div>
                <ExcelExport data={exportData} ref={_export}>
                  <ExcelExportColumn field="no" title="#" width={50} />
                  <ExcelExportColumn field="doctorName" title="Doctor Name" />
                  <ExcelExportColumn
                    field="collectedAmount"
                    title="Collected Amount"
                  />
                  <ExcelExportColumn
                    field="collectedDate"
                    title="Collected Date"
                  />
                  <ExcelExportColumn field="remark" title="Remark" />
                  <ExcelExportColumn field="status" title="Status" />
                </ExcelExport>
              </div>
            </div>
          </Paper>
        </div>
      </div>
      {/* <!-- /.content-wrapper --> */}
      <footer className="main-footer" style={{ marginTop: "50px;" }}>
        <strong>
          Copyright &copy; 2017-2020{" "}
          <a href="http://www.kwintechnologies.com">K-win Technology</a>.
        </strong>
        All rights reserved.
      </footer>

      {/* <!-- Control Sidebar --> */}
      <aside className="control-sidebar control-sidebar-dark">
        {/* <!-- Control sidebar content goes here --> */}
      </aside>

      {/* <!-- ./wrapper --> */}
    </div>
  );
}

export default PaidCommissionSummary;
